export default async (formData: FormData): Promise<any> => {
  const response = await fetch('/consultants/password-check', {
    method: 'POST',
    body: formData,
  });

  const jsonResponse = await response.json();
  jsonResponse.status = response.status;
  return jsonResponse;
};
